import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'isUserAuthenticated',
        ]),
    },
    methods: {
        fetchUnreadMessagesCount() {
            const vm = this;

            // Don't fetch messages count if user is not authenticated
            if (!this.isUserAuthenticated) {
                return;
            }

            this.messageAreLoading = true;
            Vue.backendApi()
                .emailAPI({
                    url: '/console/api/v1/mailbox/unread-messages-count',
                    method: 'get',
                    data: { email: vm.userKaoshiEmail },
                })
                .then(onSuccess, onError);

            function onSuccess(response) {
                vm.messageAreLoading = false;
                vm.$store.commit(
                    'storeUnreadMessagesCount',
                    response.data.count,
                );
                return true;
            }

            function onError(err) {
                vm.messageAreLoading = false;
                vm.$swal({
                    type: 'error',
                    title: 'We were unable to fetch your email',
                    text: err,
                });
            }
        },
    },
};
